import { deliveryMethods, shipmentStatuses } from '@reveni-io/reveni-ui'

export const trackingTypes = {
  shipment: 'shipment',
  return: 'return',
  fulfillment: 'order_fulfillment_tracking',
}

export const returnStatusLabels = {
  [shipmentStatuses.ready]: 'Devolución pendiente',
  [shipmentStatuses.shipped]: 'Devolución enviada',
  [shipmentStatuses.delivered]: 'Entregado',
  [shipmentStatuses.cancelled]: 'Cancelado',
  [deliveryMethods.customerpickup]: 'Recogida solicitada',
}
